<template>
  <div class="container">
    <div class="page-title">
      <div class="title">下载记录</div>
      <div class="marquee">
        <div class="text">
          <p>温馨提示：1. 勿将图库内模板上传至第三方素材网站用于无偿或有偿分享、售卖，如有违反，我们保留向您追偿的权利，谢谢合作；
            2. 自下载之日起算7天内再次下载，不重复减扣下载次数。
          </p>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="content-top">
        <div class="first-line">
          <div class="date-box">
            <div class="label" style="width: 40px;">日期:</div>
            <el-date-picker
              v-model="value2"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right">
            </el-date-picker>
          </div>
          <el-button style="margin:0 10px;" type="success" size="small" icon="el-icon-search" @click="query">查询</el-button>
        </div>
      </div>
      <div class="content-bottom">
        <el-table
          :data="tableData"
          stripe
          style="width: 100%"
          v-loading="listLoading"
          :row-class-name="tableRowClassName"
        >
          >
          <el-table-column
            prop="wineName"
            label="文件信息"
            width="400">
            <template slot-scope="scope">
              <div class="file-info">
                <img class="file-image" src="../../../assets/imgs/load.png" alt="">
                <div class="info-box">
                  <div class="info-title"> {{scope.row.fileName}} </div>
                  <div class="info-id"> ID: {{scope.row.id}} </div>
<!--                  <div class="info-type"> 格式：{{scope.row.type}} </div>-->
                </div>
              </div>
            </template>
          </el-table-column>
<!--          <el-table-column-->
<!--            prop="wineName"-->
<!--            label="回访周期"-->
<!--            width="140">-->
<!--            <template slot-scope="scope">-->
<!--              <div style="display: flex;align-items: center;">-->
<!--                <img style="width: 100%;height: 100%;object-fit: contain;" :src="baseURL + '/images'+item.imgSmallUrl">-->
<!--                {{scope.row.id}}-->
<!--              </div>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column
            prop="fileType"
            label="文件类型"
            width="80">
          </el-table-column>
          <el-table-column
            prop="fileSize"
            label="文件大小"
            width="80">
          </el-table-column>
          <el-table-column
            label="下载时间"
            width="180">
            <template slot-scope="scope">
<!--              {{scope.row.createTime | rTime}}-->
              {{ scope.row.downTime | rTime }}
            </template>
          </el-table-column>
          <el-table-column
            label="下载归属"
            width="120">
            我的
          </el-table-column>
         <el-table-column
            label="操作"
            width="160">
            <template slot-scope="scope">
                <el-button :disabled="!scope.row.downUrlShow" @click="getFileDownload(scope.row.fileId, scope.row.fileName )" size="small" type="primary">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :page-sizes="[5, 10, 20, 40]"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="total"
      >
      </el-pagination>
        <el-dialog
      title="下载提示"
      :visible.sync="dialogVisible"
      width="30%">
      <el-link style="margin-right: 20px;" type="primary" v-if="downUrl" @click="download(downUrl)">下载链接1</el-link>
      <el-link type="primary" v-if="downUrl1" @click="download(downUrl1)">下载链接2</el-link>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
  </span>
    </el-dialog>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        detail: {},  //详情
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        tableData: [],
        options: [],

        total: 0,
        pageSize: 10,
        currentPage:1,
        listLoading: false,
        customerCount: '',
      dialogVisible: false,
        value2: '',
        downUrl: '',
        downUrl1: '',
        baseURL: ''
      };
    },
    created () {
      this.baseURL = window.baseURL;
    },
    activated () {
      this.queryData(this.currentPage,this.pageSize);
      // this.$http.post('/dictionary/findChildListByParentId/1', { parentId: 1 }, { headers: {
      //     token: window.sessionStorage.manageToken
      //   }})
      //   .then(res => {
      //     console.log('res====',res)
      //     if (res.data.code === 'ok') {
      //       console.log('resdatadata====eateryOptions',res.data.data)
      //       this.eateryOptions = res.data.data;
      //       // this.$router.push({ path: "/layout" });
      //     } else {
      //       this.$message.error(res.data.data)
      //     }
      //   });
      // this.$http.post('/dictionary/findChildListByParentId/2', { parentId: 2 }, { headers: {
      //     token: window.sessionStorage.manageToken
      //   }})
      //   .then(res => {
      //     console.log('res====',res)
      //     if (res.data.code === 'ok') {
      //       console.log('resdatadata====areaNameOptions',res.data.data)
      //       this.areaNameOptions = res.data.data;
      //       // this.$router.push({ path: "/layout" });
      //     } else {
      //       this.$message.error(res.data.data)
      //     }
      //   });
      // this.$http.post('/dictionary/findChildListByParentId/3', { parentId: 3 }, { headers: {
      //     token: window.sessionStorage.manageToken
      //   }})
      //   .then(res => {
      //     console.log('res====',res)
      //     if (res.data.code === 'ok') {
      //       console.log('resdatadata====wineNameOptions',res.data.data)
      //       this.wineNameOptions = res.data.data;
      //     } else {
      //       this.$message.error(res.data.data)
      //     }
      //   });
      // this.findCustomerStatus()
    },
    methods: {
       getFileDownload(fileId, fileName){
        this.listLoading = true;
        this.$http.post(`/user/getFileDownload?fileId=${fileId}&fileName=${fileName}`, {
          fileId, fileName
        }, { headers: {
            token: window.sessionStorage.manageToken
          }})
          .then(res => {
            this.listLoading = false;
            console.log('res====',res)
            if (res.data.code === 'ok') {
              console.log('resdatadata====',res.data.data)
              const data = res.data.data;
              this.dialogVisible = true;
                this.downUrl = data.downUrl;
              this.downUrl1 = data.downUrl1;
            } else {
              this.$message.error(res.data.data)
            }
          });
      },
        download(downUrl){
        window.open(downUrl);
      },
      changeHandler(value) {
        this.currentPage = 1;
        this.queryData(this.currentPage,this.pageSize);
      },
      query(){
        this.currentPage = 1;
        this.queryData(this.currentPage,this.pageSize);
      },
      findCustomerStatus(){
        this.$http.post(`/customer/findCustomerStatus`, {}, { headers: {
            token: window.sessionStorage.manageToken
          }})
          .then(res => {
            this.listLoading = false;
            console.log('res====',res)
            console.log('resdata====',res.data)
            //  console.log("输出response.data", res.data);
            // this.shopOptions = res.data;
            if (res.data.code === 'ok') {
              console.log('resdatadata====',res.data.data)
              this.customerCount = res.data.data && res.data.data.visitStatus;
              // this.$router.push({ path: "/layout" });
            } else {
              this.$message.error(res.data.data)
            }
          });
      },
      toSetCyclePeriod(id,cyclePeriod){
        if(!cyclePeriod) return
        this.$http.post(`/customer/findCustomerDetail/setCyclePeriod`, {id,cyclePeriod}, { headers: {
            token: window.sessionStorage.manageToken
          }})
          .then(res => {
            this.listLoading = false;
            console.log('res====',res)
            console.log('resdata====',res.data)
            //  console.log("输出response.data", res.data);
            // this.shopOptions = res.data;
            if (res.data.code === 'ok') {
              console.log('resdatadata====',res.data.data)
              this.queryData(this.currentPage,this.pageSize);
              // this.$router.push({ path: "/layout" });
            } else {
              this.$message.error(res.data.data)
            }
          });
      },
      reset(){
        this.accountName = '';
        this.selectId = '';
        this.nextBuyChecked = false;
        this.currentPage = 1;
        this.queryData(this.currentPage,this.pageSize);
      },
      queryData(currentPage,pageSize){
        this.$http.post(`/user/userDownPage/${currentPage}/${pageSize}`, {}, { headers: {
            token: window.sessionStorage.manageToken
          }})
          .then(res => {
            this.listLoading = false;
            console.log('res====',res)
            if (res.data.code === 'ok') {
              console.log('resdatadata====',res.data.data)
              this.tableData = res.data.data.list;
              this.total = res.data.data.total;
            } else {
              this.$message.error(res.data.data)
            }
          });
      },
      handleSizeChange: function (size) {
        this.pageSize = size;
        console.log(this.pageSize);  //每页下拉显示数据
        this.queryData(this.currentPage,this.pageSize);
      },
      handleCurrentChange: function(currentPage){
        this.currentPage = currentPage;
        console.log(this.currentPage);  //点击第几页
        this.queryData(this.currentPage,this.pageSize);
      },
      rowClick(item){
        console.log(item)
        this.$router.push({ name: "OrderList",query:{accountId:item.id} });
      },
      changevisitStatus(val,id){
        console.log('val==',val,id)
        this.$http.post("/customer/updateCustomerVisitStatus", {id: id, visitStatus: val}, { headers: {
            token: window.sessionStorage.manageToken
          }})
          .then(res => {
            console.log('res====',res)
            if (res.data.code === 'ok') {
              console.log('resdatadata====',res.data.data)
              this.$message.success('回访状态修改成功')
              this.queryData(this.currentPage,this.pageSize);
            } else {
              this.$message.error(res.data.data)
            }
          });
      },
      tableRowClassName({row, rowIndex}) {
        console.log('row',row)
        if (row.nextBuy === 1) {
          return 'red-row';
        }
        return '';
      }
    },
    filters: {
      rTime(data) {
        if(!data) return
        var dt = new Date(data);
        var y = dt.getFullYear();
        var m = (dt.getMonth()+1).toString().padStart(2,"0");
        var d = dt.getDate().toString().padStart(2,"0");
        var h = dt.getHours().toString().padStart(2,"0");
        var mm = dt.getMinutes().toString().padStart(2,"0");
        var s = dt.getSeconds().toString().padStart(2,"0");
        return `${y}-${m}-${d} ${h}:${mm}:${s}`;
      },
    }
  };
</script>
<style lang="less" scoped>
  /deep/ .red-row {
    color: red;
  }
  .container {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
  }
  .content {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: auto;
    .content-top {
      display: flex;
      margin-top: 10px;
      /*justify-content: flex-start;*/
      flex-direction: column;
    }
    .first-line {
      display: flex;
      justify-content: flex-start;
      margin-bottom: 20px;
    }
    .label {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      /*text-align: right;*/
      font-size: 16px;
      color: #000000;
      padding-right: 10px;
    }
    .date-box {
      display: flex;
      align-items: center;
      padding-left: 12px;
    }
    .third-line {
      margin-left: 20px;
      margin-top: 10px;
    }
  }
  .content-bottom {
    overflow: auto;
    margin-bottom: 10px;
    flex: 1;
    padding-left: 12px;
  }
  .file-info {
    display: flex;
    align-items: center;
    .file-image {
      width: 100px;
      object-fit: contain;
      margin-right: 50px;
    }
    .info-box {
      .info-title {
        margin-bottom: 30px;
        font-weight: 600;
      }
    }
  }
  .title {
    margin-right: 20px;
    width: 80px;
  }
  .marquee {
    overflow: hidden;
    white-space: nowrap;
    .text {
      display: inline-block;
      animation-name: marquee;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
      animation-play-state: running;
      animation-duration: 35s;
    }
  }
  @keyframes marquee {
    from { transform: translateX(100%);}
    to { transform: translateX(-100%);}
  }
</style>
